var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngleBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0002 11.0898L12.7102 15.3298C12.5224 15.5191 12.2668 15.6256 12.0002 15.6256C11.7336 15.6256 11.478 15.5191 11.2902 15.3298L7.05019 11.0898C6.86088 10.902 6.75439 10.6464 6.75439 10.3798C6.75439 10.1132 6.86088 9.85757 7.05019 9.66981C7.44023 9.28208 8.07016 9.28208 8.46019 9.66981L12.0002 13.2098L15.5402 9.66981C15.7265 9.48506 15.9779 9.38091 16.2402 9.37981C16.506 9.37827 16.7615 9.48262 16.9502 9.66981C17.1463 9.85082 17.2619 10.1027 17.2713 10.3694C17.2806 10.6361 17.1831 10.8955 17.0002 11.0898Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleBottom);
export default __webpack_public_path__ + "static/media/angle-bottom.98b46ee6.svg";
export { ForwardRef as ReactComponent };